/* eslint-disable */

import React from 'react';
import styles from './styles/styles.module.css';
import { MdPeople } from 'react-icons/md';
import { TiDocumentText } from 'react-icons/ti';
import { LiaNetworkWiredSolid } from 'react-icons/lia';
import { useNavigate } from 'react-router-dom';
import { AiOutlineDashboard } from 'react-icons/ai';
import { FaGear } from 'react-icons/fa6';
import { useSelector } from 'react-redux';
import { CiBoxList } from 'react-icons/ci';
import { MdOutlineInventory } from 'react-icons/md';
import { FaRoute } from 'react-icons/fa';
import { MdEventNote } from 'react-icons/md';
import { LuPackage2 } from 'react-icons/lu';

import { selectPreEndCheckForSite } from '../../Redux/slices/visitorLogSlice';

const Sidebar: React.FC<unknown> = () => {
  const navigate = useNavigate();

  const {
    userType,
    companyPermissions = {},
    sitePermissions = {},
  } = useSelector((state: any) => state.user);

  const selectedSiteId = useSelector((state: any) => {
    return (
      state.currentSite?.siteId ||
      state.currentSite?._id ||
      state.currentSite?.currentSite?.siteId ||
      state.user?.lastSelectedSite?.lastSelectedId ||
      state.user?.user?.lastSelectedSite?.lastSelectedId
    );
  });

  const activePreEndCheck = useSelector((state: any) =>
    selectPreEndCheckForSite(state, selectedSiteId)
  );

  const openVisitorCount = activePreEndCheck?.openVisitors?.length ?? 0;
  const shouldBlinkVisitors = openVisitorCount > 0;

  function canViewSetup() {
    if (userType === 'HYPER_ADMIN' || userType === 'COMPANY_ADMIN') {
      return true;
    }

    if (Object.values(sitePermissions).some((flag) => flag === true)) {
      return true;
    }

    if (Object.values(companyPermissions).some((flag) => flag === true)) {
      return true;
    }

    return false;
  }

  function menuItemClass(isAlert = false) {
    return `${styles.menuItemContainer} ${
      isAlert ? styles.menuItemContainerAlert : ''
    }`;
  }

  return (
    <div className={styles.wrapper}>
      <div className={styles.topContainer}>
        <div className={styles.imageContainer}>
          <img
            className={styles.companyLogo}
            alt="CompanyLogo"
            src="/assets/companyLogo.png"
          />

          <div className={styles.headlineContainer}>
            <p className={styles.headline1}>Execu</p>
            <p className={styles.headline2}>Dev</p>
          </div>
        </div>

        <div className={styles.middleContainer}>
          <div
            onClick={() => navigate('/dashboard')}
            className={styles.menuItemContainer}
          >
            <AiOutlineDashboard size={23} className={styles.icon} />
            <p className={styles.menuItem}>Dashboard</p>
          </div>

          <div
            onClick={() => navigate('/visitor_log')}
            className={menuItemClass(shouldBlinkVisitors)}
            title={
              shouldBlinkVisitors
                ? `${openVisitorCount} visitor${
                    openVisitorCount === 1 ? '' : 's'
                  } still on-site before shift change`
                : undefined
            }
          >
            <MdPeople size={23} className={styles.icon} />

            <p className={styles.menuItem}>
              Visitors
              {shouldBlinkVisitors && (
                <span className={styles.alertBadge}>{openVisitorCount}</span>
              )}
            </p>
          </div>

          <div
            onClick={() => navigate('/red_zone_report')}
            className={menuItemClass()}
            title={
              shouldBlinkVisitors
                ? `${openVisitorCount} visitor${
                    openVisitorCount === 1 ? '' : 's'
                  } still on-site before shift change`
                : undefined
            }
          >
            <FaRoute size={23} className={styles.icon} />

            <p className={styles.menuItem}>Red Zone</p>
          </div>

          <div
            onClick={() => navigate('/deliveries')}
            className={menuItemClass()}
            title={
              shouldBlinkVisitors
                ? `${openVisitorCount} visitor${
                    openVisitorCount === 1 ? '' : 's'
                  } still on-site before shift change`
                : undefined
            }
          >
            <LuPackage2 size={23} className={styles.icon} />

            <p className={styles.menuItem}>Deliveries</p>
          </div>

          <div
            onClick={() => navigate('/incident_report')}
            className={menuItemClass()}
          >
            <MdEventNote size={23} className={styles.icon} />

            <p className={styles.menuItem}>Incident Report</p>
          </div>

          {/* <div
            onClick={() => navigate('/deliveries')}
            className={menuItemClass()}
            
          >
            <LuPackage2 size={23} className={styles.icon} />

            <p className={styles.menuItem}>Deliveries Log</p>
          </div> */}

          {/* <div
            onClick={() => navigate('/reports')}
            className={styles.menuItemContainer}
          >
            <TiDocumentText size={23} className={styles.icon} />
            <p className={styles.menuItem}>Reports</p>
          </div> */}

          {/* <div
            onClick={() => navigate('/inventories')}
            className={styles.menuItemContainer}
          >
            <MdOutlineInventory size={23} className={styles.icon} />
            <p className={styles.menuItem}>Inventories</p>
          </div>

          <div
            onClick={() => navigate('/checklists')}
            className={styles.menuItemContainer}
          >
            <CiBoxList size={23} className={styles.icon} />
            <p className={styles.menuItem}>Checklists</p>
          </div> */}

          {/* <div
            onClick={() => navigate('/custody_trackers')}
            className={styles.menuItemContainer}
          >
            <LiaNetworkWiredSolid size={23} className={styles.icon} />
            <p className={styles.menuItem}>Custody Trackers</p>
          </div> */}
        </div>

        <div className={styles.bottomContainer}>
          {canViewSetup() && (
            <div
              onClick={() => navigate('/setup')}
              className={styles.menuItemContainer}
            >
              <FaGear size={23} className={styles.icon} />
              <p className={styles.menuItem}>Setup</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
